<template>

  <div v-if="load">
    <scale-loader/>
  </div>

  <tabs v-else-if="specification_is_load" parent="specification">
    <tab id="info" :name="translate('specification.section.info')" :href="url+'/info'">
      <SpecificationInfo v-if="specification_is_load"
        :specification="specification_info"
        @update="update_specification"
        @get_spec="get_specification"
      />
    </tab>

    <tab id="settings" :name="translate('specification.section.settings')" :href="url+'/settings'">
      <SpecificationSettings v-if="specification_is_load"
         :specification="specification_info"
         @update="update_specification"
         @get_spec="get_specification"
      />
    </tab>
  </tabs>

  <div v-else>
    <div class="wrapper-full-page section content">
      <div class="container">
        <div class="row">
          <div class="col-md-8 col-md-offset-2 text-center">
            <h2 class="title text-danger">
              Specification: {{cur_id}} not found
            </h2>
            <router-link :to="{path:'/production/specifications'}">
              To Specification list
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>


</template>
<script>
import {Tabs, Tab} from 'components/UIComponents/Tabs'
import SpecificationInfo from './Tabs/Info/Info.vue'
import SpecificationSettings from './Tabs/Settings/Settings.vue'

export default {
  name: 'Specification',
  components: {
    SpecificationInfo,
    SpecificationSettings,
    Tab,
    Tabs,
  },
  data () {
    return {
      section: 'info',
      specification_info: null,
    }
  },

  computed: {
    url () { return '/specification/' + this.$route.params.specification_id },
    cur_id () { return this.$route.params.specification_id },
    load () { return !this.specification_info?.id },
    specification_is_load() { return this.specification_info !== null }
  },
  watch: {
    cur_id () {
      if (this.cur_id && this.$route.name === 'specification_section') {
        this.get_specification()
      }
    }
  },

  activated(){
    this.get_specification()
  },

  methods: {
    update_specification(data){
      this.specification_info = data
    },
    get_specification () {
      this.$http.v1.getSpecificationInfo(this.$route.params.specification_id, (response) => {
        this.specification_info = response.data
        this.specification_info.items = this.specification_info.items.map(item => {
          return {...item, planned_finish_date_ts: (new Date(item.planned_finish_date)/1000)}
        })
      })
    }
  }
}

</script>
